import { Component, ChangeDetectionStrategy } from '@angular/core';
import { StepperComponent } from '../../components/form/stepper/stepper.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from '../../components/form/service';
import { ConfigService } from '../../../../../../config.service';
import { ORGANIZATIONS } from '../../../../../data/organizations';
import { RouteParamService } from '../../../../../services/route-param.service';
import { format, parseISO } from 'date-fns';
import { ShuttelbussService } from '../../../../../../services/shuttlebuss.service';
import { Flightinfo } from '../../../../../../models/flightModel';
import { BookingConfigService } from '../../../../../services/booking-config.service';
import moment from 'moment';

@Component({
  selector: 'app-start',
  imports: [StepperComponent],
  templateUrl: './start.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './start.component.scss'
})
export class StartBookingComponent {

  private _organization: string = '';
  parkingGroup: any;
  hotels: any;
  flights: any;
  searchData: any;
  site: any;

  constructor(private route: ActivatedRoute,
    private _formService: FormService,
    private router: Router,
    private routeParamService: RouteParamService,
    private _shuttlebussService: ShuttelbussService,
    private bookingConfigService: BookingConfigService
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
    if (this.site !== 'quality' && this.site !== 'quality-xpo-arlanda') {
      localStorage.removeItem('quality-public');
    }
    if (this.site !== 'aiden' && this.site !== 'aiden-short-term') {
      localStorage.removeItem('aiden-public');
    }
    const routerState = this.router.getCurrentNavigation();
    if (routerState?.extras?.state) {
      let extras = routerState?.extras;
      if (this.site == 'quality' || this.site == 'aiden') {
        const searchData = routerState?.extras?.state?.['searchData'] ?? null;

        const arrivalFlight = searchData?.['arrivalFlight'] ?? null;
        const departureFlight = searchData?.['departureFlight'] ?? null;
        const isArrivalByFlight = searchData?.['isArrivalByFlight'] ?? false;
        const arrivalTerminal = searchData?.['arrivalTerminal'] ?? null;
        const departureTerminal = searchData?.['departureTerminal'] ?? null;

        this._formService.selectedDepartureFlight = departureFlight;
        this._formService.selectedArrivalFlight = arrivalFlight;
        this._formService.isDepartureHotel = searchData?.['isDepartureHotel'] ?? false;
        this._formService.isArrivalByFlight = isArrivalByFlight;
        this._formService.arrivalTerminal = arrivalTerminal;
        this._formService.departureTerminal = departureTerminal;

        const departureRoute = searchData?.departureRoute;
        const selectedShuttleBusDeparture = departureRoute ? (
          typeof departureRoute === 'string' ? this.deserializeRoute(JSON.parse(departureRoute)) :
            this.deserializeRoute(departureRoute)
        ) : null;

        const arrivalRoute = searchData?.arrivalRoute;
        const selectedShuttleBusArrival = arrivalRoute ? (
          typeof arrivalRoute === 'string' ? this.deserializeRoute(JSON.parse(arrivalRoute)) :
            this.deserializeRoute(arrivalRoute)
        ) : null;

        if (selectedShuttleBusArrival?.startDate) {
          this._formService.arrivalPickup = (selectedShuttleBusArrival.startDate);
        }
        if (selectedShuttleBusDeparture?.startDate) {
          this._formService.departurePickup = (selectedShuttleBusDeparture.startDate);
        }
        this._formService.setFormValues(searchData);
      }
      else {
        const arrivalFlight = routerState?.extras?.state?.['arrival_flight'] ?? null;
        const departureFlight = routerState?.extras?.state?.['departure_flight'] ?? null;
        const departureHotel = routerState?.extras.state?.['departure_hotel'] ?? null;
        const arrivalHotel = routerState?.extras.state?.['arrival_hotel'] ?? null;

        this._formService.selectedDepartureFlight = departureFlight;
        this._formService.selectedArrivalFlight = arrivalFlight;
        this._formService.departureHotel = departureHotel;
        this._formService.arrivalHotel = arrivalHotel;

        const searchData = routerState?.extras?.state?.['searchData'] ?? null;
        this._formService.setFormValues(searchData);
      }

      const selectedParking = routerState?.extras?.state?.['selectedParking'] ||
        history.state?.['selectedParking'] ||
        routerState?.extras?.state?.['searchData']?.['selectedParking'] ||
        history.state?.['searchData']?.['selectedParking'];
      if (selectedParking) {
        this._formService.selectedParking = selectedParking;
      }

      const orgId = extras?.state?.['org'] ?? null;
      if (orgId) {
        this._formService.organization = ORGANIZATIONS.find(org => org.name == orgId.toUpperCase());
      } else {
        if (this.site) {
          this._formService.organization = ORGANIZATIONS.find(org => org.name == this.site.toUpperCase());
        }
      }
    }
    else {
      // Check URL parameters, sessionStorage and localStorage for booking data
      let saved = this.route.snapshot.paramMap.get('booking_data') ||
        this.route.snapshot.queryParamMap.get('booking_data') ||
        sessionStorage.getItem('bookingData') ||
        localStorage.getItem('bookingData');
      if (saved) {
        try {
          const state = JSON.parse(saved);
          const arrivalFlight = state['arrival_flight'] ?? null;
          const departureFlight = state['departure_flight'] ?? null;
          const departureHotel = state['departure_hotel'] ?? null;
          const arrivalHotel = state['arrival_hotel'] ?? null;
          const orgId = state['org'] ?? null;
          const searchData = state['searchData'] ?? null;

          if (orgId) {
            this._formService.organization = ORGANIZATIONS.find(org => org.name == orgId.toUpperCase());
          } else {
            if (this.site) {
              this._formService.organization = ORGANIZATIONS.find(org => org.name == this.site.toUpperCase());
            }
          }

          // Clear state once used
          sessionStorage.removeItem('widget-booking-state');
          localStorage.removeItem('bookingData');

          // Handle quality & aiden site data specially
          if ((this.site === 'quality' || this.site === 'aiden') && searchData) {
            const isArrivalByFlight = searchData?.['isArrivalByFlight'] ?? false;
            const arrivalTerminal = searchData?.['arrivalTerminal'] ?? null;
            const departureTerminal = searchData?.['departureTerminal'] ?? null;

            this._formService.selectedDepartureFlight = departureFlight;
            this._formService.selectedArrivalFlight = arrivalFlight;
            this._formService.isDepartureHotel = searchData?.['isDepartureHotel'] ?? false;
            this._formService.isArrivalByFlight = isArrivalByFlight;
            this._formService.arrivalTerminal = arrivalTerminal;
            this._formService.departureTerminal = departureTerminal;

            const departureRoute = searchData?.departureRoute;
            const selectedShuttleBusDeparture = departureRoute ? (
              typeof departureRoute === 'string' ? this.deserializeRoute(JSON.parse(departureRoute)) :
                this.deserializeRoute(departureRoute)
            ) : null;

            const arrivalRoute = searchData?.arrivalRoute;
            const selectedShuttleBusArrival = arrivalRoute ? (
              typeof arrivalRoute === 'string' ? this.deserializeRoute(JSON.parse(arrivalRoute)) :
                this.deserializeRoute(arrivalRoute)
            ) : null;

            if (selectedShuttleBusArrival?.startDate) {
              this._formService.arrivalPickup = (selectedShuttleBusArrival.startDate);
            }
            if (selectedShuttleBusDeparture?.startDate) {
              this._formService.departurePickup = (selectedShuttleBusDeparture.startDate);
            }
            this._formService.setFormValues(searchData);
          } else {
            // Non-quality sites
            this._formService.selectedDepartureFlight = departureFlight;
            this._formService.selectedArrivalFlight = arrivalFlight;
            this._formService.departureHotel = departureHotel;
            this._formService.arrivalHotel = arrivalHotel;
            this._formService.setFormValues(searchData);
          }

        } catch (e) {
          console.error('Invalid booking state:', e);
        }

      }
    }
  }

  deserializeRoute(route: any): any {
    if (!route) {
      return null;
    }
    return {
      ...route,
      startDate: route.startDate ? (
        typeof route.startDate === 'string' ? moment(route.startDate) :
          (route.startDate._isAMomentObject ? route.startDate : moment(route.startDate))
      ) : null,
      endDate: route.endDate ? (
        typeof route.endDate === 'string' ? moment(route.endDate) :
          (route.endDate._isAMomentObject ? route.endDate : moment(route.endDate))
      ) : null
    };
  }

  ngOnInit() {
    this.parkingGroup = this._formService.getForm().get('parkingGroup');
    this.hotels = this._formService.getForm().get('hotels');
    this.flights = this._formService.getForm().get('flights');
    this.searchData = this._formService.getForm().get('search');

    let parkingStart: string | null = "";
    let parkingEnd: string | null = "";
    let departureFlight: string | null = "";
    let departureFlightDate: string | null = "";
    let arrivalFlight: string | null = "";
    let arrivalFlightDate: string | null = "";
    let departureHotel: any | null = "";
    let departureHotelDate: string | null = "";
    let arrivalHotel: any | null = "";
    let arrivalHotelDate: string | null = "";
    let showSubscription: string | null = "";

    // this.route.queryParamMap.subscribe(params => {
    this.route.paramMap.subscribe(params => {
      parkingStart = params.get("parking_start");
      parkingEnd = params.get("parking_end");

      showSubscription = params.get("show_subscription");

      departureFlight = params.get("departure_flight");
      departureFlightDate = params.get("departure_flight_date");
      arrivalFlight = params.get("arrival_flight");
      arrivalFlightDate = params.get("arrival_flight_date");

      departureHotel = params.get("departure_hotel");
      departureHotelDate = params.get("departure_hotel_date");
      arrivalHotel = params.get("arrival_hotel");
      arrivalHotelDate = params.get("arrival_hotel_date");

      let discountCode = params.get('discount_code');

      switch (this.site) {
        case 'tui': discountCode = 'TUI10'; break;
        case 'nazar': discountCode = 'Nazar'; break;
      }

      if (discountCode) {
        if (discountCode.toUpperCase() === 'NONE' || discountCode === 'null') {
          this._formService.discountCode = '';
        } else {
          this._formService.discountCode = discountCode;
        }
      }

      if (parkingStart && parkingEnd) {
        this._formService.searchStartDate = new Date(parkingStart)
        this._formService.searchEndDate = new Date(parkingEnd);

        this.searchData.controls.departureDatetime.setValue(this._formService.searchStartDate)
        this.searchData.controls.arrivalDatetime.setValue(this._formService.searchEndDate)
      }
      if (departureFlight && departureFlightDate) {
        this.findFlightByFlightnrAndDate(departureFlight, departureFlightDate, 'departure').then(res => {
          this.parkingGroup.controls.departureFlight.setValue(res);
          this.flights.controls.departureFlight.setValue(res);
          this.searchData.controls.departureFlightDate.setValue(departureFlightDate);
          this._formService.updatedDepartureFlight = res;
        })
      }
      if (arrivalFlight && arrivalFlightDate) {
        this.findFlightByFlightnrAndDate(arrivalFlight, arrivalFlightDate, 'arrival').then(res => {
          this.parkingGroup.controls.arrivalFlight.setValue(res);
          this.flights.controls.arrivalFlight.setValue(res);
          this.searchData.controls.arrivalFlightDate.setValue(arrivalFlightDate);
        });
      }
      if (departureHotel && departureHotelDate) {
        let departureHotelObj = {
          value: departureHotel,
          viewValue: departureHotel
        };
        this.hotels.controls.departureHotel.setValue(departureHotelObj);
        this.hotels.controls.departureDatetime.setValue(this._formService.searchStartDate);
        this._formService.departureHotel = departureHotelObj;
      }
      if (arrivalHotel && arrivalHotelDate) {
        let arrivalHotelObj = {
          value: arrivalHotel,
          viewValue: arrivalHotel
        };
        this.hotels.controls.arrivalHotel.setValue(arrivalHotelObj);
        this.hotels.controls.arrivalDatetime.setValue(this._formService.searchEndDate);
        this._formService.arrivalHotel = arrivalHotelObj;
      }

      this._organization = params.get('organization') || '';
      if (this._organization) {
        this.routeParamService.setOrg(this._organization);
        this._formService.organization = ORGANIZATIONS.find(org => org.name == this._organization.toUpperCase());
      }

    });
  }

  findFlightByFlightnrAndDate(flightNumber: string, flightDate: string, type: string): Promise<Flightinfo | null> {
    let date = parseISO(flightDate);
    let dateString = format(date, 'yyyy-MM-dd');
    return new Promise((resolve, reject) => {
      this._shuttlebussService.getFlights(dateString, type).subscribe({
        next: (FlightList: Flightinfo[]) => {
          let Timekey: string = type + "Time";
          let matchedFlight = FlightList.find(flight => {
            let flightTime: any = flight[Timekey as keyof Flightinfo];
            return flight.flightId === flightNumber &&
              flight.locationAndStatus.flightLegStatus !== 'DEL' &&
              flight.locationAndStatus.flightLegStatus !== 'Deleted' &&
              flightTime.scheduled > '2024-04-17';
          });
          if (matchedFlight) {
            resolve(matchedFlight);
          } else {
            resolve(null);
          }
        },
        error: (error: any) => {
          reject(error);
        },
        complete: () => {
        }
      });
    });
  }
}
